import Tooltip from '@material-ui/core/Tooltip';
import { IconButton } from "@material-ui/core";
import {
	CreateOutlined,
	DeleteOutlined,
	VisibilityOutlined,
} from "@material-ui/icons";
import React from "react";
import moment from "moment";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import requests from '../../../Services/HttpServices';
import { hasLampadaPersoConnessione } from '../../../Services/LampadaServices';
import GeneralTable from "../../NewComponent/GeneralTable";
import Checkbox from "@material-ui/core/Checkbox";

let closeModalFixed = false;
const LAMPADA_ICON_FALLBACK = "/api/images/lamp-anomalia.png";

function getIdAbbonato(lampadaData) {
	const rawIdAbbonato = lampadaData?.abbonato?.idAbbonato != null
		? lampadaData.abbonato.idAbbonato
		: lampadaData?.idAbbonato;
	const idAbbonato = parseInt(rawIdAbbonato, 10);

	return !Number.isNaN(idAbbonato) && idAbbonato !== 0 ? idAbbonato : null;
}

function createFallbackAbbonato(idAbbonato) {
	return {
		idAbbonato,
		nome          : "",
		cognome       : "",
		codiceFiscale : "",
		indirizzo     : "",
		sdi           : "",
		telefono      : "",
		mail          : "",
		mailPec       : "",
	};
}

function loadAbbonato(lampadaData, idAbbonato) {
	if (lampadaData.abbonato != null) { return Promise.resolve(lampadaData.abbonato); }

	const bodydata = {};
	bodydata["idAbbonato"] = idAbbonato;
	return requests("post", "lampadaAbbonato", bodydata).then((data) => {
		if (data?.result === "success" && data?.lampadaAbbonato) {
			lampadaData.abbonato = data.lampadaAbbonato;
			return data.lampadaAbbonato;
		}

		return createFallbackAbbonato(idAbbonato);
	});
}

function getLampadaIconSrc(lampadaData, lampadaDisconnessa) {
	if (lampadaDisconnessa && lampadaData?.statoLampadaEffettivo == 1) { return "/api/images/lamp-accesa-non-connessa.png"; }
	if (lampadaDisconnessa && lampadaData?.statoLampadaEffettivo == 0) { return "/api/images/lamp-spenta-non-connessa.png"; }
	if (lampadaData?.statoLampadaEffettivo == 1) { return "/api/images/lamp-accesa.png"; }
	if (lampadaData?.statoLampadaEffettivo == 0) { return "/api/images/lamp-spenta.png"; }

	return LAMPADA_ICON_FALLBACK;
}

export default function LampadePanelTableWrapper(props) {
	const filter = {
		serialeLampada  : "",
		idDefunto : "",
		statoLampada  : "",
		modalita  : "",
	};
	const tableHeaderName = [
		{
			id       : "selezione",
			maxWidth : 50,
			label    : " ",
			align    : "center",
		},
		{
			id       : "serialeLampada",
			maxWidth : 110,
			label    : "Seriale",
			align    : "center",
		},
		{
			id       : "nomeDefunto",
			label    : "Defunto",
			align    : "center",
		},
		{
			id       : "dataMorte",
			label    : "Morte",
			align    : "center",
		},
		{
			id       : "cimitero",
			label    : "Cimitero",
			align    : "center",
		},
		{
			id    : "nomeAbbonato",
			label : "Abbonato",
			align : "center",
		},
		{
			id    : "scadenza",
			maxWidth : 130,
			label : "Scadenza",
			align : "center",
		},
		{
			id       : "statoLampada",
			label    : "Stato",
			align    : "center",
		},
		{
			id    : "modalita",
			label : "Modalità",
			align : "center",
		},
		{
			id    : "azioni",
			maxWidth : 100,
			label : "Azioni",
			align : "center",
		},
	];
	return (
		<div>
			<a href="#" id="tempLink" style={{ display: "none" }} target="_blank" />
			<GeneralTable
				initOrder="live"
				partner
				type={props.type}
				filter={filter}
				deleteAllOperation={props.deleteAllOperation}
				setChecked={props.setChecked}
				setFilter={props.setFilter}
				setNumber={() => {
				}}
				setAllNumber={() => {
				}}
				headData={tableHeaderName}
				onRowClick={props.onRowClick}
				clickable
				data={props.data}
				actionData={(
					<div>
						<CreateOutlined fontSize="small" className="dash-icon" />
						<VisibilityOutlined fontSize="small" className="dash-icon" />
						<DeleteOutlined fontSize="small" className="dash-icon" />
					</div>
				)}
			/>
		</div>
	);
}

export function createLampadeDataPartnerTable(lampadaData, setState) {

	//Lampada
	let serialeLampada = lampadaData.serialeLampada;
	const idAbbonato = getIdAbbonato(lampadaData);
	const lampadaDisconnessa = hasLampadaPersoConnessione(lampadaData);
	let statoLampadaBase = "❗ In anomalia";
  	if (lampadaData.statoLampadaEffettivo == 1) { statoLampadaBase = "✅ Accesa"; }
  	if (lampadaData.statoLampadaEffettivo == 0) { statoLampadaBase = "❌ Spenta"; }
	let statoLampada = statoLampadaBase;
	if (lampadaDisconnessa) { statoLampada = `${statoLampadaBase}, Non connessa`; }
	const lampadaIconSrc = getLampadaIconSrc(lampadaData, lampadaDisconnessa);
	let modalita = "Spenta";
	if (lampadaData.statoLampadaImpostato == 1) { modalita = "Sempre Accesa"; }
	if (lampadaData.statoLampadaImpostato == 2) { modalita = "Effetto Fiamma"; }
	if (lampadaData.statoLampadaImpostato == 3) { modalita = "Evanescenza"; }
	let scadenza = moment(lampadaData.dataTermineAccensione).format("DD/MM/YYYY");

	//Defunto
	const defunto = lampadaData.defunto || {};
	let nomeDefunto = `${defunto.name || ""} ${defunto.surname || ""}`.trim() || `ID ${lampadaData.idDefunto || "Non disponibile"}`;
	let dataMorte = defunto.dateOfDeath === "0000-00-00" || !defunto.dateOfDeath ? "Non disponibile" : defunto.dateOfDeath;
	let cimitero = defunto.graveLocation || "Non disponibile";
	if (defunto.graveProvince) { cimitero += ` (${defunto.graveProvince})`; }
	
	//Abbonamento
	let nomeAbbonato = "Nessuno";
	if (lampadaData.abbonato != null) { nomeAbbonato = lampadaData.abbonato.nome + " " + lampadaData.abbonato.cognome; }
	else if (idAbbonato != null) { nomeAbbonato = `ID ${idAbbonato}`; }
	

	//Selezione
	const selezione = (
		<div>
			<Checkbox color="primary" name="selezione" value={1} />
		</div>
	);

	//Azioni
	const azioni = (
		<div>
			<Tooltip title="Gestisci Lampada">
				<IconButton
					size="small"
					onClick={e => {
						e.stopPropagation();
						const bodydata = {};
						bodydata["seriale"] = parseInt(lampadaData.serialeLampada, 10);
						requests("post", "lampadeCollegateLoad", bodydata).then((data) => {
							if (data?.result === "success") {
								setState({ lampadaDataState: lampadaData, lampadeCollegateState: data?.lampadeCollegate, showLampadePopupNome: nomeDefunto, showLampadePopup: true })
							}
							else {
								setState({ lampadaDataState: lampadaData, lampadeCollegateState: [], showLampadePopupNome: nomeDefunto, showLampadePopup: true })
							}
						});
					}}
					className="icon-button"
				>
				<img
					id="lamp-status"
					alt={statoLampada}
					src={lampadaIconSrc}
					style={{ height: 38 }}
					className="dash-icon"
					onError={(e) => {
						if (!e.currentTarget.src.endsWith(LAMPADA_ICON_FALLBACK)) {
							e.currentTarget.src = LAMPADA_ICON_FALLBACK;
						}
					}}
				/>
				</IconButton>
			</Tooltip>

			{idAbbonato != null && (
				<Tooltip title="Gestisci Abbonato">
					<IconButton
						size="small"
						onClick={e => {
							e.stopPropagation();
							loadAbbonato(lampadaData, idAbbonato).then((abbonatoData) => {
								const bodydata = {};
								bodydata["seriale"] = parseInt(lampadaData.serialeLampada, 10);
								bodydata["abbonato"] = idAbbonato;
								requests("post", "lampadaPagamenti", bodydata).then((data) => {
									if (data?.result === "success") {
										setState({ abbonatoDataState: abbonatoData, serialeLampadaState: lampadaData.serialeLampada, lampadaTermineState: lampadaData.dataTermineAccensione, storicoPagamentiState: data?.lampadaPagamenti, showAbbonatoPopup: true })
									}
									else {
										setState({ abbonatoDataState: abbonatoData, serialeLampadaState: lampadaData.serialeLampada, lampadaTermineState: lampadaData.dataTermineAccensione, storicoPagamentiState: [], showAbbonatoPopup: true })
									}
								});
							});
						}}
						className="icon-button"
					>
					<AccountCircleIcon style={{ fontSize: 24 }} />
					</IconButton>
				</Tooltip>
			)}
		</div>
	);

	return {
		selezione,
		serialeLampada,
		nomeDefunto,
		dataMorte,
		cimitero,
		nomeAbbonato,
		scadenza,
		statoLampada,
		modalita,
		azioni
	};
}
